(function(){
  var KEYS = ['utm_source','utm_medium','utm_campaign','utm_term','utm_content'];
  var store = window.__utmStore || {};
  // Read once more (in case of internal nav)
  try {
    KEYS.forEach(function(k){
      var v = localStorage.getItem(k);
      if (v) store[k] = v;
    });
  } catch (e){}

  function inject(){
    // Default cart / checkout forms
    var form = document.querySelector('form[action="/cart"], form[action^="/checkout"]');
    if (!form) return;
    KEYS.forEach(function(k){
      var v = store[k]; if(!v) return;
      var sel = 'input[name="attributes['+k+']"]';
      var input = form.querySelector(sel);
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'attributes['+k+']';
        form.appendChild(input);
      }
      input.value = v;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', inject, {once:true, passive:true});
  } else { inject(); }

  // Optional: fire event if GA is ready now (else it was queued in HEAD)
  if (Object.keys(store).length){
    if (window.gtag) window.gtag('event','utm_parameters_detected', store);
  }
})();